import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";

export default function CartMail() {
  const [subject, setsubject] = useState("");
  const [email, setemail] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);


  function submit() {
    if (!subject || !email) {
      setError(true);
      return;
    }
    const data = { subject, email, id:1 };

    setsubmitLoader(true);
    PostService(API_URL.UPDATE_CART_MAIL, data).then(
      (res) => {
        if (res.data.status === true) {
          setsubmitLoader(false)
          getCartMail()
          showSuccessAlert(res?.data?.message, getCartMail);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  }

  useEffect(() => {
    getCartMail();
  }, []);

  const getCartMail = async () => {
    // setLoading(true)
    PostService(API_URL.GET_CART_MAIL).then((res) => {
      if (res.data?.status === true) {
        setemail(res.data?.data?.email);
        setsubject(res.data?.data?.subject);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Cart Mail</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Cart Mail</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            {/* <h4 class="card-title">Add Company Details</h4> */}
            <div className="row offset-md-1">
              <div className="col-12 form-group">
                <label>Subject</label>
                <input
                  type="Subject"
                  placeholder="Enter Subject"
                  className="form-control"
                  value={subject}
                  onChange={(e) => setsubject(e?.target?.value)}
                />
                 {error && !subject && (
                        <div className="error mt-1">Subject is required</div>
                      )}
              </div>
              <div className="col-12 form-group">
                <label>Message</label>
                <CKEditor
                    editor={ClassicEditor}
                    data={email}  
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setemail(data)
                    }}
                  /> 
                 {error && !email && (
                        <div className="error mt-1">Message is required</div>
                      )}
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => submit()}
                >
                   {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                 
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
             <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
